export const prepareEmailFpayDataSource = (validator, country, id, formValues) => {
  return {
    ...validator,
    globalStateValues: {
      country,
      [id]: formValues[id]
    }
  };
};
